import { Box, type BoxProps } from "../box/Box";
import { forwardRef } from "../../../utils/theme-tools";

/**
 * FullBleed component allows content to "break out" of a constrained parent container
 * (like a 1920px max-width layout) and span the full width of the viewport.
 *
 * It uses the negative margin trick to visually expand beyond the parent boundaries
 * while remaining in the same DOM position.
 */
export const FullBleed = forwardRef<BoxProps, "div">(({ children, ...props }, ref) => {
    return (
        <Box ref={ref} position="relative" w="100vw" marginInline="calc(50% - 50vw)" {...props}>
            {children}
        </Box>
    );
});
